import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SearchableSelect, type SearchableSelectOption } from "./SearchableSelect";
import { cn } from "@/lib/utils";

interface AdminDashboardQuickNavProps {
  propertyOptions: SearchableSelectOption[];
  workerOptions: SearchableSelectOption[];
  propertyValue: string;
  workerValue: string;
  onPropertyChange: (value: string) => void;
  onWorkerChange: (value: string) => void;
  className?: string;
}

export function AdminDashboardQuickNav({
  propertyOptions,
  workerOptions,
  propertyValue,
  workerValue,
  onPropertyChange,
  onWorkerChange,
  className,
}: AdminDashboardQuickNavProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // CRITICAL: Nawigacja bezwarunkowa i synchroniczna – bez await, bez zależności od stanu rodzica.
  // navigate() wywołane najpierw, żeby uniknąć batchowania re-renderu i "wiecznego" spinnera.
  const handlePropertySelect = (value: string) => {
    if (value) navigate(`/properties/${value}`);
    onPropertyChange(value);
  };

  const handleWorkerSelect = (value: string) => {
    if (value) navigate(`/workers/${value}`);
    onWorkerChange(value);
  };

  return (
    <div
      className={cn(
        "flex flex-col gap-4 sm:flex-row sm:items-end rounded-lg border border-border bg-card p-4",
        className
      )}
    >
      <div className="grid flex-1 gap-2">
        <label className="text-sm font-medium text-muted-foreground">
          {t("admin.nav.goToProperty")}
        </label>
        <SearchableSelect
          options={propertyOptions}
          value={propertyValue}
          onValueChange={handlePropertySelect}
          placeholder={t("admin.nav.selectProperty")}
          searchPlaceholder={t("admin.nav.searchAddress")}
          emptyText={t("admin.nav.noProperties")}
        />
      </div>
      <div className="grid flex-1 gap-2">
        <label className="text-sm font-medium text-muted-foreground">
          {t("admin.nav.goToWorker")}
        </label>
        <SearchableSelect
          options={workerOptions}
          value={workerValue}
          onValueChange={handleWorkerSelect}
          placeholder={t("admin.nav.selectWorker")}
          searchPlaceholder={t("admin.nav.search")}
          emptyText={t("admin.nav.noWorkers")}
        />
      </div>
    </div>
  );
}
